import { createAction, props } from "@ngrx/store";
import {User} from "cli-types";


// ------ Load teacherMetrics ------
export const loadTeacherMetrics = createAction(
    "[Teacher] Load Teacher Metrics",
    props<{
        payload: string;
    }>()
);
export const loadTeacherMetricsFail = createAction(
    "[Teacher] Load Teacher Metrics Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadTeacherMetricsSuccess = createAction(
    "[Teacher] Load Teacher Metrics Success",
    props<{
        payload: User;
    }>()
);
